import {
  onDislikeContent,
  onFavoriteContent,
  onLikeContent
} from "../queries/contentActions";

export function useContentActions() {

  return {
    onLikeContent,
    onDislikeContent,
    onFavoriteContent
  }
}
